/* eslint-disable react/jsx-handler-names */
import './TextAreaResizer.scss';
import React from 'react';

class TextAreaResizer extends React.Component {
    constructor() {
        super();
        this.state = {
            value: '',
            heightLocal: '46px',
            lengthText: 0,
            maxLengthLocal: 500,
        };
    }

    componentDidMount() {
        const { initialHeight, maxLength } = this.props;
        if (initialHeight) {
            this.setState({ heightLocal: `${initialHeight}px` });
        }

        if (maxLength) {
            this.setState({ maxLengthLocal: maxLength });
        }
    }

    onChangeHandler = e => {
        const target = e.target;
        const { heightLocal } = this.state;
        if (target.value === '') {
            target.style.height = heightLocal;
            return this.setState({ value: '', lengthText: 0 });
        } else {
            this.setState({ value: target.value, lengthText: target.value.length });
        }
    };

    handleKeyDown = e => {
        const { style, scrollHeight } = e.target;
        const { heightLocal } = this.state;
        const numberInitialHeight = Number(heightLocal.slice(0, -2));
        style.height = `${Math.max(numberInitialHeight, scrollHeight)}px`;
    };

    render = () => {
        const { classStyle, name, id, value, setValue, label, labelClass, autoFocus } = this.props;
        const { heightLocal, lengthText, maxLengthLocal } = this.state;

        return (
            <React.Fragment>
                <div className={`col-md-12 ${labelClass}`}>
                    <label>{label}</label>
                </div>
                <div className="col-md-12">
                    <textarea
                        className={'textarea ' + classStyle}
                        name={name}
                        id={id}
                        maxLength={maxLengthLocal}
                        style={{
                            height: heightLocal,
                        }}
                        autoFocus={autoFocus}
                        value={value}
                        rows={1}
                        onChange={event => {
                            setValue(event.target.value), this.onChangeHandler(event);
                        }}
                        onKeyDown={this.handleKeyDown}
                    />
                </div>
                <div className="col-md-12" style={{ opacity: 0.5, textAlign: 'end' }}>
                    {lengthText} / {maxLengthLocal}
                </div>
            </React.Fragment>
        );
    };
}

export default TextAreaResizer;
